<template>
  <div>
    <!-- <h3 class="text-center text-h5 pa-3 text-decoration-underline">
      Users Report
    </h3> -->
    <v-col cols="5" md="10" sm="6" class="mx-auto">
      <download-csv :data="this.JsonFormat" name="report.csv">
        <v-btn
          small
          rounded
          class="ml-6 btn-help-video"
          @click="checkJson"
          color="success"
        >
          CSV Export
        </v-btn>
      </download-csv>
    </v-col>
    <v-row justify="center" class="mt-2 mx-2">
      <v-data-table
        :headers="Headers"
        :items="reportData"
        :items-per-page="10"
        class="elevation-1 trial-table"
        mobile-breakpoint="0"
      >
        <template v-slot:item.createdAt="{ item }">
          <p>{{ item.createdAt | UtcToEst }}</p>
        </template>

        <template v-slot:item.isfree="{ item }">
          <p v-if="item.isfree === '0'">Paid</p>

          <p v-else-if="item.isfree === '1' && item.plantype === 'Free'">NO</p>
          <p v-else-if="item.isfree === '1' && item.plantype !== 'Free'">YES</p>
        </template>

        <template v-slot:item.paying_amount="{ item }">
          <p
            v-if="item.status == 'trialing' || item.status == 'canceled'"
            class="green--text"
          >
            <b>$</b>0.00
          </p>

          <p v-else class="green--text">
            <b>$</b> {{ item.paying_amount / 100 }}
          </p>
        </template>
      </v-data-table>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "newTrialTable",
  props: {
    reportData: {
      type: [Array, Object],
      default: () => {},
    },
  },
  data() {
    return {
      JsonFormat: [],
      Headers: [
        { text: "Email", value: "email" },
        { text: "Source", value: "source" },
        { text: "Campaign", value: "campaign" },
        { text: "Medium", value: "medium" },
        { text: "Term", value: "term" },
        { text: "Content", value: "content" },
        { text: "Plan Type", value: "plantype" },
        {
          text: "Plan Swtich",
          value: "isfree",
          align: "center",
        },
        { text: "Payment Amount", value: "paying_amount" },
        { text: "Date & Time", value: "createdAt" },
      ],
    };
  },

  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("role") !== "client") {
      next({ name: "Pricing" });
    } else {
      next();
    }
  },

  methods: {
    backButton() {
      this.$router.go(-1);
    },

    checkJson() {
      // debugger;
      this.JsonFormat = [];
      this.JsonFormat = this.reportData.map((item) => {
        let newObj = {
          Email: item.email,
          Source: item.source,
          Campaign: item.campaign,
          Medium: item.medium,
          Term: item.term,
          Content: item.content,
          Plan_Swtich:
            item.isfree === "0"
              ? "Paid"
              : item.isfree === "1" && item.plantype === "Free"
              ? "No"
              : item.isfree === "1" && item.plantype !== "Free"
              ? "Yes"
              : "_",
          Plan_Type: item.plantype,
          Payment_Amount:
            item.status == "trialing" || item.status == "canceled"
              ? "0.00"
              : item.paying_amount / 100,
        };

        return newObj;
      });
      console.log("JsonFormat", this.JsonFormat);
      return this.JsonFormat;
    },
  },
};
</script>

<style scoped>
.trial-table >>> .v-data-table-header__icon {
  opacity: 1;
}
</style>
